import { InfoResponse } from "../api/InfoResponse";
import apiClient from "./core/ApiClient";
import { ContactRequest } from "@/api/ContactRequest";

const getInfo = (): Promise<InfoResponse> =>
  apiClient.get<InfoResponse>("/api/info/ping");

const sendContact = (
  name: string,
  email: string,
  message: string,
  captcha?: string
): Promise<void> => {
  let payload: ContactRequest = {
    name: name,
    email: email,
    message: message,
    captcha: captcha ?? null,
  };
  return apiClient.post<ContactRequest, void>("/api/info/contact", payload);
};

export const infoService = {
  getInfo: getInfo,
  sendContact
};
